import { DeliveryState } from "../../../type/delivery-state";

interface Action {
  type: string;
  payload: {
    id: string;
  };
}

export const setSelectedDisplayDeliveryIdDispatch = (
  state: DeliveryState,
  action: Action
) => {
  const { id } = action.payload;
  state.selectedDisplayDeliveryId = id;
};
